import ConsignmentStock from "../../models/ConsignmentStock"

export default {
  data() {
    return {
      visible: true,
    }
  },

  methods: {
    close() {
      this.$router.go(-1)
    },

    save() {
      this.$emit("loading")

      ConsignmentStock
        .renew(this.$route.params.id)
        .then(response => this.$emit("consignmentstockupdate", response, "La demande de renouvellement a été envoyée"))
        .catch(reason => this.$emit("consignmentstockupdateerror", reason))
        .then(() => this.close())
    },
  },
}
